 /*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
// @ts-ignore
import Button from './../button/./button';
// @ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IState {
  imageWidth:number;
  height:any;
}

interface IProps {
  title?:string;
  preTitle?:string;
  description?:string;
  image?:any;
  buttonLink?:string;
  buttonText?:string;
  theme?:string;
  direction?:string;
  resizeMode?:string;
  height?:string;
}

/**
 *
 * SideBySideTextAndImage component
 * @extends {React.Component<SideBySideTextAndImage>}
 */

class SideBySideTextAndImage extends React.Component<IProps,IState> {

  public state: IState;
  public imageRef = React.createRef<HTMLDivElement>();

  constructor(props: IProps) {
    super(props);
    this.imageRef = React.createRef();
    this.state = {
      imageWidth:100,
      height:'auto'
    };
  }

  public componentDidMount = () => {
     window.addEventListener("resize", this.updateDimensions);
     this.updateDimensions();
  }

  public updateDimensions = () => {
    if(this.imageRef.current){
      let imageWidth = this.imageRef.current.getBoundingClientRect().width;
      this.setState({
        imageWidth:imageWidth
      })
    }
    let height = window.outerHeight;
    this.setState({
      height:height
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  public render(): JSX.Element {

    let directionClass:string = 'right';
    if(this.props.direction){
      directionClass = this.props.direction;
    }
    let resizeMode:any = 'cover';
    if(this.props.resizeMode){
      resizeMode = this.props.resizeMode;
    }
    let height:any =  'none';
    if( this.props.height ==  "threeQuarter"){
      height = height*0.75;
    }
    if( this.props.height ==  "half"){
      height = height*0.5;
    }
    if( this.props.height ==  "quarter"){
      height = height*0.25;
    }
    if( this.props.height ==  "auto"){
      height = 'none';
    }

    return (
      <div className={`side-by-side-image-and-text-wrapper`}>
        <div className={`side-by-side-image-and-text ${directionClass}  ${this.props.theme}`}>
          {this.props.image &&
            <div className='side-by-side-image-and-text-image-block background-image-fill' style={{backgroundImage:`url(${ this.props.image })`, backgroundSize:resizeMode}}>
              <img src={GeneralAssetUrl+'square.png'} className="full-width" style={{height:'auto',minHeight:height}} />
            </div>
          }
          <div className={`side-by-side-image-and-text-text-block ${this.props.theme}`} style={{minHeight:this.state.imageWidth}}>
            <div className='side-by-side-image-and-text-text-block-inner small-padding'>
              {this.props.preTitle && <h5 className='side-by-side-image-and-text-pre-title uppercase subheading'>{this.props.preTitle}</h5>}
              {this.props.title && <h4 className='side-by-side-image-and-text-title text-color-primary'>{this.props.title}</h4>}
              {this.props.description && <div className='side-by-side-image-and-text-description subheading medium-margin-top'>{this.props.description}</div>}
              {this.props.buttonLink && <Button
                className='side-by-side-image-and-text-button button'
                text={this.props.buttonText}
                href={this.props.buttonLink}
                target={'_blank'}
              />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SideBySideTextAndImage;
